import {createPostRequest, createRequest, makeRequest, prepareRequest} from "../utils/apiUtil";

export function getById(id, includes = []) {
    return makeRequest(createRequest('partner/' + id), prepareRequest({}, includes));
}
export function loginAs(id, includes = []) {
    return makeRequest(createPostRequest('partner/' + id + '/loginas'));
}